import style from '../style/Report.module.scss';
import {Link} from "react-router-dom";
import className from 'classnames/bind';
import ActionBar from "~/layout/ActionBar";
import Icon from "~/components/Icon";
import {useCan} from "~/hooks";
const cn = className.bind(style);

function Report() {
	const can = {
		'saleAnalytic': useCan('reportSaleAnalytic'),
		'salePoint': useCan('reportSalePoint'),
		'sale': useCan('reportSale'),
		'commit': useCan('reportSaleCommit'),
		'revenue': useCan('reportRevenue'),
		'extend': useCan('reportExtend'),
		'pay': useCan('reportPay'),
		'financial': useCan('reportFinancial'),
		'debt': useCan('reportDebt'),
		'website': useCan('reportFinancial'),
		'contractRank': useCan('reportContractRank'),
		'contract': useCan('reportContract'),
	}
	/*Sale: Điểm tư vấn*/
	const ItemSalePoint = () => {
		if(!can.salePoint) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.point}</div>
			<div className={cn('info')}>
				<Link to={'sales/point'}>
					<h3 className={'text-lg'}>Điểm tư vấn</h3>
					<p>Thống kê điểm làm việc hằng ngày</p>
				</Link>
			</div>
		</div>)
	}
	/*Sale: Lịch hẹn*/
	const ItemSaleEvent = () => {
		if(!can.salePoint) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.point}</div>
			<div className={cn('info')}>
				<Link to={'sales/event'}>
					<h3 className={'text-lg'}>Lịch hẹn & tư vấn</h3>
					<p>Thống kê báo cáo cuộc hẹn, tư vấn</p>
				</Link>
			</div>
		</div>)
	}
	/*Sale: cam kết*/
	const ItemSaleCommit = () => {
		if(!can.commit) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.point}</div>
			<div className={cn('info')}>
				<Link to={'sales/commit'}>
					<h3 className={'text-lg'}>Cam kết</h3>
					<p>Thống kê báo cáo cam kết</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Doanh thu*/
	const ItemRevenue = () => {
		if(!can.revenue) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.dola}</div>
			<div className={cn('info')}>
				<Link to={'revenue'}>
					<h3 className={'text-lg'}>Doanh thu</h3>
					<p>Báo cáo doanh thu công ty</p>
				</Link>
			</div>
		</div>)
	}
	/*Extend: Gia hạn*/
	const ItemExtend = () => {
		if(!can.extend) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.dola}</div>
			<div className={cn('info')}>
				<Link to={'extend'}>
					<h3 className={'text-lg'}>Gia hạn</h3>
					<p>Báo cáo doanh thu gia hạn</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Lương*/
	const ItemPay = () => {
		if(!can.pay) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'pay'}>
					<h3 className={'text-lg'}>Lương</h3>
					<p>Báo cáo lương từng phòng ban</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Điểm*/
	const ItemPoint = () => {
		if(!can.pay) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'point'}>
					<h3 className={'text-lg'}>Điểm</h3>
					<p>Báo cáo điểm từng nhân viên</p>
				</Link>
			</div>
		</div>)
	}
	/*Revenue: Thu chi*/
	const ItemFinancial = () => {
		if(!can.financial) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'financial'}>
					<h3 className={'text-lg'}>Tài chính</h3>
					<p>Báo cáo tài chính tình hình thu chi, lương</p>
				</Link>
			</div>
		</div>)
	}
	/*Service: Website*/
	const ItemWebsite = () => {
		if(!can.website) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'website'}>
					<h3 className={'text-lg'}>Website</h3>
					<p>Báo cáo thống kê tình hình website</p>
				</Link>
			</div>
		</div>)
	}
	//Công nợ
	const ItemDebt = () => {
		if(!can.debt) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'debt'}>
					<h3 className={'text-lg'}>Công nợ</h3>
					<p>Danh sách dịch vụ chưa thanh toán</p>
				</Link>
			</div>
		</div>)
	}

	//Xếp hạng hợp đồng
	const ItemContractRank = () => {
		if(!can.contractRank) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'contract-rank'}>
					<h3 className={'text-lg'}>Hạng hợp đồng</h3>
					<p>Danh sách xếp hạng hợp đồng</p>
				</Link>
			</div>
		</div>)
	}

	//hợp đồng
	const ItemContract = () => {
		if(!can.contract) return null;
		return (<div className={cn('item')}>
			<div className={cn('icon')}>{Icon.wallet}</div>
			<div className={cn('info')}>
				<Link to={'contract'}>
					<h3 className={'text-lg'}>Hợp đồng</h3>
					<p>Báo cáo hợp đồng</p>
				</Link>
			</div>
		</div>)
	}

	return (
		<>
			<ActionBar title={'Báo cáo'}></ActionBar>
			<div className="container" style={{display: 'block'}}>
				<div className="content">
					<div className={cn('items', 'gap-1')}>
						<ItemSaleEvent />
						<ItemSaleCommit />
						<ItemSalePoint />
						<ItemPoint />
						<ItemContractRank />

						<ItemContract />
						<ItemWebsite />
						<ItemDebt />

						<ItemRevenue />
						<ItemExtend />
						<ItemPay />
						<ItemFinancial />
					</div>
				</div>
			</div>
		</>
	)
}

export default Report;